import React, {ReactElement} from 'react';
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from '@mui/icons-material/Close';
import {useMediaQuery, useTheme} from "@mui/material";


const DialogHeader = ({title, closeAction, recordResultDialog}: { title: string | ReactElement, closeAction?: () => void, recordResultDialog?: boolean }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const isTablet = useMediaQuery(theme.breakpoints.between('md', 'lg'))

    return (
        <>
            <DialogTitle sx={{
                m: 0,
                p: isMobile ? "16px" : "10px",
                pl: isMobile ? "16px" : 5,
                display: 'flex',
                justifyContent: isMobile ? 'center' : 'start',
                alignItems: 'center',
                fontSize: 18,
                fontWeight: 700,
                borderBottom: isMobile ? "none" : "none",
                bgcolor: isMobile ? "#ffffff" : "#FD3300",
                color: isMobile ? "#1D1A1A" : "#ffffff"
            }}>
                {title}
            </DialogTitle>
            {closeAction &&
                <IconButton
                    aria-label="close"
                    onClick={() => closeAction()}
                    disableRipple={true}
                    sx={{
                        position: 'absolute',
                        right: isMobile ? 15 : 34,
                        top: isMobile ? 10 : 3, 
                        color: isMobile ? '#1D1A1A' : '#ffffff',
                        zIndex: 999
                    }}
                >
                    <CloseIcon/>
                </IconButton>
            }
        </>
    );
};


export default DialogHeader;

